import { createTitle as createAlertTitle } from '#component/project/form/alerts/alert-item/helper';

export const formatter = uid => {
  const a = uid ? uid.split('') : ['Error'];
  const { length } = a;

  return a
    .map((e, i) => (
      ((length - i) !== 0 && (length - i - 1) % 4 === 0) ? `${e} ` : e))
    .join('').trim();
};

export const mapToSelect = (devices, measurementSystem) =>
  devices.map(d => ({
    label: d.title ? `${d.title}` : `${d.uid}`,
    value: d.id,
    uid: d.uid,
    disabledBy: d.disabledBy,
    color: d.color ? d.color : null,
    type: d.type ? d.type : null,
    typeForRender: d.typeForRender ? d.typeForRender : null,
    projects: d.projects ? d.projects : null,
    alertOn: d.alertOn,
    showAlertIcon: d.showAlertIcon,
    alertLabel: d.alertOn && d.alerts?.map(a => createAlertTitle(a, 'metric', measurementSystem)).join('; '),
    chipOverview: true,
    tinted: d.tinted,
    selectedAxis: d.selectedAxis,
    projectAlertId: d.projectAlertId
  }));

export const mapSelected = (devices, selected) =>
  (selected ? selected.map(s => devices.find(d => d.id === s.value)) : []);

/**
 * @typedef {Object} ShipmentStatusObject
 * @property {number} code - shipment status code.
 * @property {string} label - shipment status label.
 * @property {string} timestamp - shipment status timestamp.
 */

/**
 * Returns shipment status derived from the backend `status` field
 * (the single source of truth, also used by the shipment list view).
 * @param {Object} shipment - shipment.
 * @returns {ShipmentStatusObject} shipment status.
 */

export const getShipmentStatus = shipment => {
  switch (shipment.status) {
    case 200:
      return { code: 2, label: 'In progress' };
    case 300:
      return { code: 3, label: 'Stopped', timestamp: shipment.done };
    case 400:
      return { code: 4, label: 'Done' };
    case 100:
    default:
      return { code: 1, label: 'Not started' };
  }
};

/**
 * Returns last completed step index or -1 if no steps completed.
 * @param {Array} steps - steps.
 * @returns {number} index.
 */

export const getLastCompletedStepIndex = steps => {
  let lastCompletedStepIndex = -1;
  for (let i = steps.length - 1; i >= 0; i -= 1) {
    if (steps[i].done) {
      lastCompletedStepIndex = i;
      break;
    }
  }

  return lastCompletedStepIndex;
};

/**
 * Returns redirect shipment path based on status code and devices length.
 * @param {object} shipment - shipment.
 * @returns {string} path.
 */
export const getRedirectPath = (shipment = {}, account = {}) => {
  const { id, delivery = [], devices = [], status: { code } = {} } = shipment;
  const { userType } = account;

  if (userType <= 20) {
    if (delivery[0]?.date && delivery[0].date <= new Date().toISOString()) {
      return `/shipment/${id}`;
    }
    if (code === 1 || (code < 3 && !devices.length)) {
      return `/shipment/edit/${id}`;
    }
  }

  return `/shipment/${id}`;
};
